export const getCompanies = state => state.companies;

export const getQuery = state => state.query;

export const loading = state => state.loading;
